const Calculators = () => {
	return <div>Calculators</div>
}

export default Calculators
